import styled from 'styled-components';

export const Container = styled.div`
  max-width: 100%;
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./src/components/ui-helpers/container.js